import React, {useState} from 'react'
import Container from '@packages/justo-parts/lib/components/Container'
import styles from './styles.module.css'
import InputButton from './InputButton'
import useMutate from '@packages/apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'
import useMessage from '@hooks/useMessage'
import Icon from 'react-icons/lib/md/email'
import {useTranslation} from 'next-i18next'

export default function CollectEmail(props) {
  const {emenu} = props
  const [email, setEmail] = useState()
  const [subscribed, setSubscribed] = useState(false)
  const mutate = useMutate()
  const showMessage = useMessage()
  const {t} = useTranslation('website', {keyPrefix: 'emenu'})

  const subscribe = async () => {
    try {
      await mutate({
        mutation: gql`
          mutation subscribeToEmailsFromEMenu($email: String, $emenuId: ID) {
            subscribeToEmailsFromEMenu(emenuId: $emenuId, email: $email)
          }
        `,
        variables: {email, emenuId: emenu._id}
      })
      setSubscribed(true)
    } catch (error) {
      showMessage(error)
    }
  }

  if (subscribed) {
    return (
      <div className={styles.container}>
        <Container>
          <div className="row middle-sm">
            <div className="col-xs-12 col-sm-6">
              <div className={styles.text}>
                <br /> {t('thankYouForSubscribing')}
                <br />
                <br />
              </div>
            </div>
          </div>
        </Container>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <Container>
        <div className="row middle-sm">
          <div className="col-xs-12 col-sm-6">
            <div className={styles.text}>{t('enterYourEmail')}</div>
          </div>
          <div className="col-xs-12 col-sm-6">
            <InputButton
              value={email}
              onChange={setEmail}
              onClick={() => subscribe()}
              buttonContent={<Icon />}
            />
          </div>
        </div>
      </Container>
    </div>
  )
}
